import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import localStorage from 'local-storage';
import { api } from '../../helper/api';

const initalState = {
    contract_address: '',
    banner: '',
    profile: '',
    tx_hash: '',
    name: '',
    symbol: '',
    royalties: 0,
    total_supply: 0,
    collection_data: []
}


export const fetchCreateCollection = createAsyncThunk('collection/fetchCreateCollection', async ({ nftAddres, hash, address ,categoryId  }, thunkAPI) => {
    try {
        let token = localStorage.get('auth_token');
        const currentState = thunkAPI.getState();
        if (token && token !== null && token !== 'null' && currentState && nftAddres && hash) {

            let response = await api.post('collection/create', {
                address,
                contract_address: nftAddres,
                banner: currentState.collection.banner,
                profile: currentState.collection.profile,
                tx_hash: hash,
                categoryId,
                token
            })

            if (response && response.data && response.data.error === 'OK') {
                return { contract_address: nftAddres, tx_hash: hash }
            }
            else {
                return { error: response.data.error }
            }
        }
        else {
            return { error: 'Something went wrong , please try again' }
        }
    }
    catch (err) {
        return { error: err.message }
    }
})



export const fetchCollectionData = createAsyncThunk('collection/fetchCollectionData', async () => {
    try {
        let response = await api.get('collection/get', {
            params: { status: 1 , limit : 4 }
        });

        if (response && response.data && response.data.error === 'OK') {
            return { collection_data: response.data.data }
        }
        else {
            return { error: response.data.error }
        }
    }
    catch (err) {
        return { error: err.message }
    }
})






export const collectionSlice = createSlice({
    name: 'collection',
    initialState: initalState,
    reducers: {
        updateField(state, action) {
            const { field, value } = action.payload;
            state[field] = value;
        },
    },
    extraReducers: (builder) => {
        //fetchCreateCollection
        builder.addCase(fetchCreateCollection.pending, (state) => {
            console.log('fetchCreateCollection pending....');
            return { ...state, loading: true }
        })
        builder.addCase(fetchCreateCollection.fulfilled, (state, action) => {
            console.log({ ...state, ...action.payload, loading: false })
            return { ...state, ...action.payload, loading: false }
        })
        builder.addCase(fetchCreateCollection.rejected, (state) => {
            console.log('fetchCreateCollection rejected...')
            return { ...state, loading: false }
        })
        //fetchCollectionData
        builder.addCase(fetchCollectionData.pending, (state) => {
            console.log('fetchCollectionData pending....');
            return { ...state, loading: true }
        })
        builder.addCase(fetchCollectionData.fulfilled, (state, action) => {
            console.log({ ...state, ...action.payload, loading: false })
            return { ...state, ...action.payload, loading: false }
        })
        builder.addCase(fetchCollectionData.rejected, (state) => {
            console.log('fetchCollectionData rejected...')
            return { ...state, loading: false }
        })
    }
})



export const { updateField } = collectionSlice.actions;
export default collectionSlice.reducer;